<template>
  <v-container
    grid-list-xl
    fluid
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
      >
        <FilterButtons
          :filters="appliedFilters"
          @filter-removed="removeFilter"
        />

        <MassActionSelect
          :actions="massActions"
          @action-selected="dispatchAction"
        />

        <CollectionFilters
          :filters="filters"
          :active-filters="appliedFilters"
          @filters-submitted="submitFilters"
          @filters-cleared="clearFilters"
        />
      </v-flex>
      <v-flex xs12>
        <v-data-table
          v-model="selected"
          :loading="loading"
          :headers="headers"
          :items="collection"
          :total-items="meta.totalItems"
          :rows-per-page-text="$t('Rows per page')"
          :rows-per-page-items="meta.rowsPerPageItems"
          :pagination.sync="pagination"
          show-select
          select-all
          class="elevation-1"
          item-key="id"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          />

          <template v-slot:items="props">
            <CustomerDataTableRow
              :props="props" />
          </template>

          <template slot="no-data">
            <v-btn
              color="primary"
              @click="clearFilters"
            >
              {{ $t('Reset') }}
            </v-btn>
          </template>
          <template v-slot:pageText="props">
            <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CustomerDataTableRow from '../components/CustomerDataTableRow'
import MassActionSelect from '../../../vuetify-console/components/MassActionSelect'
import CollectionFilters from '../../../vuetify-console/components/CollectionFilters'
import FilterButtons from '../../../vuetify-console/components/FilterButtons'

import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('customers/customers')

export default {
  name: 'CustomerList',

  components: {
    CollectionFilters,
    FilterButtons,
    CustomerDataTableRow,
    MassActionSelect
  },

  actionBar () {
    return {
      title: 'Customers',
      actions: [
        {
          text: 'Add new Customer',
          event: 'add'
        }
      ]
    }
  },

  data () {
    return {
      selected: [],
      searchQuery: ''
    }
  },

  computed: {
    ...mapGetters(['collection', 'loading', 'meta', 'appliedFilters']),

    pagination: {
      get: function () {
        return this.meta
      },
      set: function (value) {
        this.applyMeta(value)
      }
    },

    headers () {
      return [
        { text: this.$t('Name'), value: 'name' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('DOB'), value: 'dob' },
        { text: this.$t('Phone'), value: 'phone' },
        { text: this.$t('Created At'), value: 'created_at' }
      ]
    },

    massActions () {
      return [
        { code: 'delete', label: this.$t('Delete') }
      ]
    },

    filters () {
      return [
        { field: 'firstname', type: 'string', label: this.$t('First Name') },
        { field: 'lastname', type: 'string', label: this.$t('Last Name') },
        { field: 'email', type: 'string', label: this.$t('Email') },
        { field: 'dob', type: 'date', label: this.$t('Date of birth') },
        { field: 'created_at', type: 'date', label: this.$t('Created At') }
      ]
    }
  },

  methods: {
    ...mapActions(['applyMeta', 'fetchCollection', 'removeFilter', 'clearFilters']),

    setSearchQuery (query) {
      this.searchQuery = query
    },

    onActionAdd () {
      this.$router.push({ name: 'new-customer' })
    },

    dispatchAction (action) {
      if (action === 'delete') {
        this.deleteSelected()
      }
    },

    async deleteSelected () {
      let customers = null
      if (this.selected.length) {
        customers = this.selected.map(item => item.id)
      }

      await this.$http.make('customer').massDelete(customers)
      this.selected = []
      this.$toast.success(this.$t('Deleting records.'))
    },

    submitFilters (filters) {
      this.applyMeta({ filters })
    }
  }
}
</script>

<style scoped></style>
